import React from 'react';
import c from 'classnames';

import { SearchStats } from '@uncinc/react-searchkit';
import type { SearchStatsProps } from '@uncinc/react-searchkit/dist/components/Stats';

import './style.scss';

const SearchAllContentStats: React.FC<SearchStatsProps> = (props) => {
  const { className, ...restProps } = props;

  const classNames = c('SearchAllContent__Stats', className);

  return (
    <SearchStats
      {...restProps}
      className={classNames}
    />
  );
};

export default SearchAllContentStats;
